import React from 'react';
import { string, shape, arrayOf } from 'prop-types';

import { useBLazyRevalidate } from 'hooks';
import { NewsCard } from 'components/cards';
import { LISTING_CONTAINER_ID } from '../constants';

const NewsListing = ({ items }) => {
    useBLazyRevalidate(LISTING_CONTAINER_ID, [items]);

    if (!items || !items.length) {
        return null;
    }

    return (
        <div className="grid grid--cards grid--equal-height grid--cards--large-v-gutter">
            {items.map(item => (
                <div className="col-lg-4 col-sm-6" key={item.id}>
                    <NewsCard {...item} />
                </div>
            ))}
        </div>
    );
};

NewsListing.propTypes = {
    items: arrayOf(
        shape({
            id: string,
            title: string,
            url: string,
            date: string,
            dateTitle: string,
            perex: string,
            buttonTitle: string,
            image: shape({
                url: string,
                alt: string
            })
        })
    ).isRequired
};

export default NewsListing;
